/**
 * @typedef ActiveTabHookParams
 * @property {function} onTabSelect setter for the active page. Hook this up to the TabContainer onSelect
 * @property {string} activeTab The active tab
 */

export const urlParamNames = {
    ACTIVE_TAB: 'activeTab',
    ACTIVE_MENU: 'activeMenu',
    ACTIVE_STAFF: 'activeStaffTab',
    ACTIVE_LEARNERS: 'activeLearnerTab',
    ACTIVE_HOME: 'activeHomeTab',
}